<template>
  <section class="flex level-1" :class="{mobile:!mobile}">   

    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}" v-if="mobile">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h2>{{general.challengeSubTitleCommercial}}</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->

    <div  class="block__challengesAccueil  content__challengesAccueil"> 

      <!-- BREADCRUMB -->
      <b-breadcrumb class="desktop">
          <b-breadcrumb-item @click.prevent="goBack" >Challenges</b-breadcrumb-item>
          <b-breadcrumb-item active>Challenges commerciaux</b-breadcrumb-item>
      </b-breadcrumb>
      <!-- BREADCRUMB -->


      <div class="sep desktop"></div>



      <!-- //TITLE DESKTOP -->
      <div class="header desktop">
        <h1>{{general.challengeSubTitleCommercial}}</h1>
      </div>
      <!-- //TITLE DESKTOP -->


      <!-- CONTENT -->
      <b-row  v-if="lastChallengesCommercials.length">
        <b-col sm="12" lg='6' class="item" v-for="(item,index) in lastChallengesCommercials" :key="index">
          <cardChallengesCommercials
          :id = item.id
          :title = "item.user ? item.user.fullName : ''"
          :subtitle = item.criteria
          :startDate = item.startDate
          :endDate = item.endDate
          :objectiveNumber = item.objective
          :inprogress = item.score
          :state = item.target
          :isLoad.sync = isLoading
          />
        </b-col>
        <Stack class="mobile"></Stack>
      </b-row>
      <b-row  v-else>
         <b-col sm='12' md='6' class="mb-4">
           <p>Aucun challenges de commerciaux en cours</p>
         </b-col>        
      </b-row>      
      <!-- CONTENT -->

    </div>
  </section>
</template>


<script>
import { mapGetters } from 'vuex'
import cardChallengesCommercials from '../../../module/card/CardChallengesCommercials'
import ChallengesMixin from '../challenges/ChallengesMixin'
import Stack from '../../../module/stack/Stack'
import ApiService from '../../../../services/ApiService'
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'

export default {
  name:"challengesCommercials",

    components:{
      cardChallengesCommercials,
      Stack,
    }, 
    mixins: [
      ChallengesMixin      
    ], 
    computed: {
      ...mapGetters([
        'getGeneral',
          'getIsMobile'
      ])
    },
    props:{
      mobile:{
        type:Boolean,
        default:true
      }
    },
    data () {
      return {
        general:"",
        isLoading: true,
        lastChallengesCommercials: [{},{}],
      }
    },

    created (){
      this.general = this.getGeneral;
      this.isMobile = this.getIsMobile;
      this.isMobile ? this.$store.dispatch('showHeader',false) : '';
      this.getData();       
    },
    methods : {   
      async getData(){
        this.lastChallengesCommercials = await ApiService.getChallengeApi().getCommercialsChallenges(ApiAuthenticationService.getCurrentUser().id);
        this.lastChallengesCommercials = this.lastChallengesCommercials.data;
        this.isLoading = false;
      },
      goBack() {
        this.$store.dispatch('goBack');
        this.$router.push({name: "challengesHome"});  
        this.isMobile ? this.$store.dispatch('showHeader',true) : '';
      },             
    },
  watch: {
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
  };
</script>
